$(document).ready(function() {
    $('.search-filter').on('click', 'li.selected, li.title, .caret', function (e) {
        // Get the parent li (i.e. grade or subject)
        var p = $(this).parent().closest('li');

        if (p.hasClass('open')) {
            p.removeClass('open');
        }
        else {
            // When opening a menu, close all other open ones
            $('> li', p.parent()).removeClass('open');
            p.addClass('open');
        }
        return false;
    });

    $('.linkContainer .link').on('click', function (e) {
        var linkContainer = $(this).parents('.linkContainer');
        var siblings = $(linkContainer).siblings();
        if ($(linkContainer).hasClass('selected'))
        {
            //open state
            if ($(siblings).hasClass('open')) {
                $(siblings).removeClass('open');
                $(linkContainer).addClass('selectedClosed');
            }
            else {
                e.preventDefault();
                $(siblings).addClass('open');
                $(linkContainer).removeClass('selectedClosed');
            }
        }
        else {
            $(siblings).removeClass('selected').removeClass('open');
            $(linkContainer).addClass('selected open selectedClosed');
        }
    });

    $('.navigation .caret').on('click', function () {
        $('.linkContainer.open .link').click();
    })
});